import { Box, Typography, FormControlLabel } from '@mui/material';
import { MESSAGES } from '../constants/generateCouponsConstants';
import {
  RESPONSIVE_CONFIG,
  ANIMATIONS,
  FIELD_STYLES,
  CustomCheckbox,
  CustomTextField,
} from '../../../common';
import {
  formatDateForInput,
  getPaymentMethodCode,
  isSpecialPaymentMethod,
} from '../utils/generateCouponsUtils';
import VerticalForm from '../../../common/components/forms/VerticalForm';

const BottomFormSection = ({
  showAdecuacion,
  paymentMethods,
  paymentMethodUuid,
  dueDates,
  dueDatesCalendar,
  diffValues,
  noCalculateInterest,
  defermentPercentage,
  onDueDateChange,
  onDateCalendarChange,
  onInterestCheckboxChange,
}) => {
  const paymentMethodCode = getPaymentMethodCode(paymentMethods, paymentMethodUuid);
  const isSpecial = isSpecialPaymentMethod(paymentMethodCode);

  const showDifferenceColumn = defermentPercentage > 0;

  const fieldStyles = FIELD_STYLES.FLEX_NORMAL(showDifferenceColumn);

  const createDiffFieldStyles = (delay = '0s') => ({
    ...FIELD_STYLES.FLEX_FULL,
    ...ANIMATIONS.FADE_IN_DELAYED(delay),
  });

  const dueDataConfig = [
    {
      key: 'due1',
      label: 'Primer Vencimiento',
      value: dueDates.due1,
      dateValue: dueDatesCalendar.due1,
      diffValue: diffValues.diff1,
      diffDelay: '0s',
      amountDisabled: !isSpecial,
      dateDisabled: false,
    },
    {
      key: 'due2',
      label: 'Segundo Vencimiento',
      value: dueDates.due2,
      dateValue: dueDatesCalendar.due2,
      diffValue: diffValues.diff2,
      diffDelay: '0.1s',
      amountDisabled: !isSpecial,
      dateDisabled: !isSpecial,
    },
    {
      key: 'due3',
      label: 'Tercer Vencimiento',
      value: dueDates.due3,
      dateValue: dueDatesCalendar.due3,
      diffValue: diffValues.diff3,
      diffDelay: '0.2s',
      amountDisabled: !isSpecial,
      dateDisabled: !isSpecial,
    },
  ];

  return (
    <VerticalForm borderRadius>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: showAdecuacion === 'Base Abril 2004' ? 'error.main' : 'transparent',
            fontSize: RESPONSIVE_CONFIG.TYPOGRAPHIES.titleFontSize,
            fontWeight: 'bold',
            textShadow:
              showAdecuacion === 'Base Abril 2004' ? '2px 2px 4px rgba(0,0,0,0.3)' : 'none',
            transition: 'all 0.3s ease-in-out',
          }}
        >
          {MESSAGES.ADECUACION_TITLE}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: '900px',
          }}
        >
          <FormControlLabel
          sx={{ml: -0.5}}
            control={
              <CustomCheckbox
                checked={noCalculateInterest}
                onChange={(e) => onInterestCheckboxChange(e.target.checked)}
                name="noCalculateInterest"
              />
            }
            label={
              <Typography
                sx={{
                  fontSize: RESPONSIVE_CONFIG.FIELDS.fontSize,
                  fontWeight: 'medium',
                }}
              >
                {MESSAGES.NO_CALCULATE_INTEREST}
              </Typography>
            }
          />

          {dueDataConfig.map((dueConfig) => (
            <Box
              key={dueConfig.key}
              sx={{
                display: 'flex',
              }}
            >
              <CustomTextField
                value={dueConfig.value}
                type="number"
                label={dueConfig.label}
                disabled={dueConfig.amountDisabled}
                onChange={(e) => onDueDateChange(e.target.value, dueConfig.key)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  ...fieldStyles,
                  '& .MuiInputBase-input': {
                  },
                }}
                inputProps={{
                  min: 0,
                  step: 0.01,
                }}
              />

              <CustomTextField
                label="Fecha"
                type="date"
                value={formatDateForInput(
                  dueConfig.dateDisabled && dueConfig.key !== 'due1'
                    ? dueDatesCalendar.due1
                    : dueConfig.dateValue
                )}
                disabled={dueConfig.dateDisabled}
                onChange={(e) => onDateCalendarChange(e.target.value, dueConfig.key)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  ...fieldStyles,
                  '& .MuiInputBase-input': {
                  },
                }}
              />

              {showDifferenceColumn && (
                <CustomTextField
                  value={dueConfig.diffValue}
                  type="number"
                  label="Valor Diferencia"
                  disabled
                  InputLabelProps={{ shrink: true }}
                  sx={createDiffFieldStyles(dueConfig.diffDelay)}
                />
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </VerticalForm>
  );
};

export default BottomFormSection;
